// 使う広告の口を選び、全画面の広告の間隔を守る。
import { config } from "../config";
import { isAdFree } from "../entitlement";
import { createAdSense } from "./adsense";
import { dummyAds } from "./dummy";
import { noAds } from "./none";
import type { AdContext, AdProvider } from "./types";

// AdSense の番号があれば AdSense、無ければ手元とテストは見本、本番は広告なし
const provider: AdProvider = config.adsenseClient
  ? createAdSense(config.adsenseClient, {
      childDirected: config.adsChildDirected,
      bannerSlot: config.adsenseBannerSlot || undefined,
      h5: config.adsenseH5,
    })
  : config.adsSample
    ? dummyAds
    : noAds;

// 遊び始めてすぐと、前の全画面の広告のすぐあとには出さない。
let lastInterstitial = Date.now() - config.interstitialMinIntervalMs + 30_000;

export const ads = {
  name: provider.name,
  async interstitial(ctx: AdContext) {
    // 広告を消すサブスクの人には出さない
    if (isAdFree()) return { shown: false };
    if (Date.now() - lastInterstitial < config.interstitialMinIntervalMs) return { shown: false };
    const r = await provider.interstitial(ctx);
    if (r.shown) lastInterstitial = Date.now();
    return r;
  },
  // 広告を消すサブスクの人は、広告を見ずにごほうびを受け取る
  rewarded: (ctx: AdContext) => (isAdFree() ? Promise.resolve({ granted: true }) : provider.rewarded(ctx)),
  mountBanner: (el: HTMLElement, slot: "home" | "play") => {
    if (!isAdFree()) provider.mountBanner(el, slot);
  },
};
